import React from "react";
import ReactDOM from "react-dom";
import APIKeyManager from "./APIKeyManager.jsx";
export function initAPIKeyManager() {
  document.querySelectorAll(".js-api-key-manager").forEach(mount => {
    ReactDOM.render(<APIKeyManager />, mount);
  });
}
